import { getEntitiesByFpId, getEntitiesByFpIdBusinessOwners } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';
import hasDataIdentifier from '@/utils/has-data-identifier';

const getBusinessOwners = async (id: string) => {
  const businessOwnersResponse = await getEntitiesByFpIdBusinessOwners({
    path: {
      fpId: id,
    },
  });
  const ownerFpIds = businessOwnersResponse.data.map(owner => owner.fpId).filter(Boolean) as string[];
  const entitiesResponse = await Promise.all(
    ownerFpIds.filter(Boolean).map(async fpId => {
      const response = await getEntitiesByFpId({ path: { fpId } });
      return response.data;
    }),
  );
  return entitiesResponse.map(entity => {
    const bo = businessOwnersResponse.data.find(bo => bo.fpId === entity.id);
    return {
      id: entity.id,
      attributes: entity.data.map(item => item.identifier),
      name: bo?.name,
      hasPhone: hasDataIdentifier(entity, 'id.phone_number'),
    };
  });
};

const useBusinessOwners = (id: string) => {
  return useQuery({
    queryKey: ['business', id, 'business-owners'],
    queryFn: () => getBusinessOwners(id),
    enabled: !!id,
  });
};

export default useBusinessOwners;
